import { t } from "../../../i18n/translate";
import { IconPause, IconPlay } from "./icons";
import "./bigPlayPause.css";

type ComponentProps = {
  isPlaying: boolean;
  onToggle: () => void;
  disabled?: boolean;
  visible: boolean;
};

export function BigPlayPause({
  isPlaying,
  onToggle,
  disabled = false,
  visible,
}: ComponentProps) {
  return (
    <div className="big-play-pause" aria-hidden={disabled || !visible}>
      <button
        type="button"
        className={`bit-hit-area ${disabled ? "is-disabled" : ""}`}
        title={t(isPlaying ? "pause" : "play")}
        aria-label={t(isPlaying ? "pause" : "play")}
        tabIndex={disabled || !visible ? -1 : 0}
        onClick={disabled ? undefined : onToggle}
      >
        <div className={`play-icon-container ${visible ? "" : "is-hidden"}`}>
          {isPlaying ? <IconPause /> : <IconPlay />}
        </div>
      </button>
    </div>
  );
}
